export default __webpack_public_path__ + "static/media/logo-Coco-Soul.b4660774.svg";